import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
  imports: [
    RouterOutlet
  ]
})
export class AuthLayoutComponent {
    constructor() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      console.log('Ширина:', width, 'Высота:', height);
    }
}
